<div class="alert alert-danger" *ngIf="mensagemErro">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <i class="k-icon k-i-warning mr-2"></i>
      {{mensagemErro}}
    </div>
    <button type="button" class="close" aria-label="Close" (click)="fecharAlerta()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="card shadow-sm mb-4" *ngIf="integracaoFood99 && !integracaoFood99.nova && !integracaoFood99.removida">
  <div class="card-body">
    <div class="card mb-3">
      <div class="card-body ">
        <div class="text-center">
          <div class="mb-2 food99icone d-inline-block">
            <i class="icone"></i>
          </div>
          <h6 class="text-primary mb-1">
            <i class="fas fa-store mr-1"></i>
            {{integracaoFood99.nomeLoja || 'Loja 99 Food'}}
          </h6>
          <div class="text-muted small">
            <i class="fas fa-key mr-1"></i>
            ID: <strong>{{integracaoFood99.idLoja}}</strong>
          </div>

          <!-- Status e ações da loja -->
          <div class="store-info mt-3">
            <div class="d-flex justify-content-between align-items-center">
              <div >
                <small class="text-muted d-block">Loja no 99 Food:</small>
                <strong>
                <span class="text-success" *ngIf="estaAberta99Food() === true">
                  <i class="k-icon k-i-check mr-1"></i>Aberta
                </span>
                <span class="text-danger" *ngIf="estaAberta99Food() === false" [hidden]="estaDesconectada99Food()">
                  <i class="k-icon k-i-pause mr-1"></i>Fechada
                </span>

                  <span class="text-danger" *ngIf="estaDesconectada99Food() ">
                  <i class="k-icon k-i-pause mr-1"></i> Desconectada
                </span>

                  <span class="text-muted" *ngIf="estaAberta99Food() === null">
                  <i class="k-icon k-i-loading mr-1"></i>
                </span>
                </strong>
                <div class="small text-muted" *ngIf="statusMensagem99Food()">
                  {{statusMensagem99Food()}}
                </div>
              </div>
              <div [hidden]="estaAberta99Food() === null || estaDesconectada99Food()">
                <button class="btn btn-success btn-sm" type="button"
                        (click)="abrirLoja99Food()"
                        [disabled]="ativando"
                        [hidden]="estaAberta99Food() === true">
                  <i class="fas fa-power-off mr-1" [hidden]="ativando"></i>
                  <i class="k-icon k-i-loading mr-1" [hidden]="!ativando"></i>
                  Abrir a loja
                </button>
                <button class="btn btn-danger btn-sm ml-2" type="button"
                        (click)="fecharLoja99Food()"
                        [disabled]="ativando"
                        [hidden]="estaAberta99Food() === false">
                  <i class="fas fa-power-off mr-1" [hidden]="ativando"></i>
                  <i class="k-icon k-i-loading mr-1" [hidden]="!ativando"></i>
                  Fechar a loja
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 align-items-end" [hidden]="!estaAberta99Food()">
          <div class="col-12 col-md-9 col-70">
            <div class="form-group text-left mb-0">
              <label class="form-label">Abertura/Fechamento automático da loja</label>
              <kendo-dropdownlist
                name="autoSwitch"
                [data]="autoSwitchOpcoes"
                textField="text"
                valueField="value"
                [defaultItem]="{ text: 'Selecione...', value: null }"
                [(ngModel)]="autoSwitchSelecionado"
                [disabled]="ativando || salvandoAutoSwitch">
              </kendo-dropdownlist>
              <small class="form-text text-muted mt-2">
                {{explicacaoAutoSwitch()}}
              </small>
            </div>
          </div>
          <div class="col-12 col-md-3 col-30 text-md-right mt-2 mt-md-0">
            <button class="btn btn-primary btn-sm btn-block"
                    type="button"
                    (click)="apliqueAutoSwitch()"
                    [disabled]="!autoSwitchSelecionado || salvandoAutoSwitch">
              <i class="k-icon k-i-loading mr-1" *ngIf="salvandoAutoSwitch"></i>
              Aplicar
            </button>
          </div>
        </div>

        <div class="row mt-3">
          <div class="form-group col-12">
            <div class="mt-0 mb-1 valor">
              <kendo-switch name="ativo" [(ngModel)]="integracaoFood99.aceitaCancelamento" class="mr-1"
                            [onLabel]="'Sim'" (ngModelChange)="alterouAtivarAceitarCancelamento($event)"
                            [offLabel]="'Não'"></kendo-switch>

              <label>Receber e processar solicitações de cancelamento </label>
            </div>
            <small  class="form-text text-muted">Se habilitado Lojista intermediará os cancelamentos de pedidos solicitdos pelo cliente
            </small>
          </div>

          <div class="form-group col-12">

            <div class="mt-0 mb-1  valor">
              <kendo-switch name="ativo" [(ngModel)]="integracaoFood99.aceitaReembolso" class="mr-1"
                            [onLabel]="'Sim'" (ngModelChange)="alterouAtivarAceitarReembolso($event)"
                            [offLabel]="'Não'"></kendo-switch>
              <label>Receber e processar solicitações de reembolso </label>
            </div>
            <small  class="form-text text-muted">Se habilitado Lojista intermediará os reembolsos de pedidos solicitdos pelo cliente
            </small>
          </div>
        </div>



        <div class="row mt-3 align-items-end">
          <div class="col-12 col-md-9 col-70">
            <div class="form-group text-left mb-0">
              <label class="form-label">Método de confirmação de pedidos</label>
              <kendo-dropdownlist
                name="metodoConfirmacao"
                [data]="metodosConfirmacao"
                textField="text"
                valueField="value"
                [defaultItem]="{ text: 'Selecione...', value: null }"
                [(ngModel)]="metodoConfirmacao"
                [disabled]="ativando || salvandoMetodo">
              </kendo-dropdownlist>
              <small class="form-text text-muted mt-2">
                {{explicacaoMetodo()}}
              </small>
            </div>
          </div>
          <div class="col-12 col-md-3 col-30 text-md-right mt-2 mt-md-0">
            <button class="btn btn-primary btn-block btn-sm"
                    type="button"
                    (click)="apliqueMetodoConfirmacao()"
                    [disabled]="!metodoConfirmacao || salvandoMetodo">
              <i class="k-icon k-i-loading mr-1" *ngIf="salvandoMetodo"></i>
              Aplicar
            </button>
          </div>
          <div class="col-12">
            <small *ngIf="metodoConfirmacao?.value === 1">
              <b>📌 Regra importante:</b> <br>
              Se você tentar aceitar/cancelar pedido pelo Meu Cardapio e o App do 99Food estiver offline, não funciona.
              O App do 99Food precisa estar ONLINE, mesmo que você não use ele.
            </small>

            <small *ngIf="metodoConfirmacao?.value === 2">
              Aqui a loja só confirma pedidos pelo seu Meu Cardapio. <br>
              <b>⚠ O App do Lojista</b> NÃO pode mais aceitar pedidos.
            </small>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-center mb-3">
          <span class="badge badge-success px-3 py-2">
            <i class="k-icon k-i-check mr-1"></i>
            Ativo
          </span>
        </div>
        <div class="row text-center">
          <div class="col-12 col-md-6 mb-3 mb-md-0">
            <div class="text-muted small">ATIVADA EM</div>
            <div class="font-weight-bold">
              {{integracaoFood99.dataAtivacao | date: 'dd/MM/yyyy'}}
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="text-muted small">TOKEN VÁLIDO ATÉ</div>
            <div class="font-weight-bold" *ngIf="integracaoFood99.validadeToken; else semToken">
              {{integracaoFood99.validadeToken | date: 'dd/MM/yyyy HH:mm'}}
            </div>
            <ng-template #semToken>
              <div class="font-weight-bold">—</div>
            </ng-template>
          </div>
        </div>


      </div>
    </div>

    <div class="mt-3">
      <button class="btn btn-outline-danger btn-block"
              type="button"
              (click)="confirmeRemover()"
              [disabled]="removendo">
        <i class="k-icon k-i-delete mr-1" *ngIf="!removendo"></i>
        <i class="k-icon k-i-loading mr-1" *ngIf="removendo"></i>
        Remover Integração
      </button>
    </div>

    <div class="alert alert-warning mt-3" *ngIf="confirmarRemover">
      <h6 class="alert-heading">
        <i class="k-icon k-i-warning mr-2"></i>
        Confirmar remoção
      </h6>
      <p class="mb-3">Remover a integração impedirá o recebimento automático dos pedidos do 99 Food.</p>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-secondary btn-sm mr-2" type="button" (click)="canceleRemover()">
          Cancelar
        </button>
        <button class="btn btn-danger btn-sm" type="button" (click)="removerIntegracao()" [disabled]="removendo">
          <i class="k-icon k-i-delete mr-1" *ngIf="!removendo"></i>
          <i class="k-icon k-i-loading mr-1" *ngIf="removendo"></i>
          Remover agora
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card shadow-sm" *ngIf="integracaoFood99?.nova && !integracaoFood99?.removida">
  <div class="card-header bg-primary text-white">
    <h5 class="mb-0">
      <i class="k-icon k-i-link mr-2"></i>
      Ativar integração com 99 Food
    </h5>
  </div>

  <div class="card-body">
    <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
          novalidate #frm="ngForm" (ngSubmit)="onSubmit()">

      <ng-container *ngIf="!integracaoFood99.authId">
        <div class="integration-section mb-4">
          <h6 class="text-primary mb-2">
            <i class="k-icon k-i-globe mr-2"></i>
            Passo 1: Autorizar pelo link do 99 Food
          </h6>
          <p class="text-muted small mb-3">
            Um link será aberto em nova aba para você autorizar o Meu Cardápio a acessar sua loja no 99 Food.
          </p>
          <button class="btn btn-success btn-lg"
                  type="button"
                  (click)="gereLinkAutorizacao()"
                  [disabled]="gerandoLink || ativando">
            <i class="k-icon k-i-loading mr-2" *ngIf="gerandoLink"></i>
            <i class="k-icon k-i-globe mr-2" *ngIf="!gerandoLink"></i>
            Autorizar loja
          </button>
        </div>



        <div class="integration-section"  >
          <h6 class="text-success mb-2">
            <i class="fas fa-key mr-2"></i>
            Passo 2: Informar o ID da loja autorizada
          </h6>
          <p class="text-muted small mb-3">
            Após autorizar nosso aplicativo no painel do 99 Food, copie o ID da loja e informe abaixo.
          </p>

          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="form-label">ID da loja 99 Food</label>
                <kendo-textbox
                  name="idLojaManual"
                  [(ngModel)]="idLojaManual"
                  placeholder="Ex: 123456"
                  required
                  #idLojaManualCtrl="ngModel">
                </kendo-textbox>
                <div class="invalid-feedback">
                  <p *ngIf="idLojaManualCtrl.errors?.required">Obrigatório</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 d-flex align-items-end">
              <button class="btn btn-success btn-lg w-100"
                      type="button"
                      (click)="ativeManualmenteLoja()"
                      [disabled]="ativando || !idLojaManualCtrl.valid">
                <i class="k-icon k-i-loading mr-2" *ngIf="ativando"></i>
                <i class="k-icon k-i-check mr-2" *ngIf="!ativando"></i>
                Ativar integração
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="integracaoFood99.authId">
        <div class="integration-section mb-4">
          <h6 class="text-success mb-2">
            <i class="k-icon k-i-check mr-2"></i>
            Autorizar concluído! Selecione a loja
          </h6>
          <p class="text-muted small mb-3">
            Escolha qual loja autorizada você deseja vincular ao Meu Cardápio.
          </p>

          <div class="form-group">
            <label class="form-label">Loja disponível</label>
            <kendo-dropdownlist
              name="lojaSelecionada"
              [(ngModel)]="integracaoFood99.lojaSelecionada"
              [data]="integracaoFood99.lojasAtivar"
              textField="name"
              valueField="id"
              required
              #lojaSelecionadaCtrl="ngModel">
            </kendo-dropdownlist>
            <div class="invalid-feedback">
              <p *ngIf="lojaSelecionadaCtrl.errors?.required">Obrigatório</p>
            </div>
          </div>

          <div class="card border-success" *ngIf="integracaoFood99.lojaSelecionada">
            <div class="card-body">
              <h6 class="card-title text-success mb-1">
                {{integracaoFood99.lojaSelecionada.name}}
              </h6>
              <p class="mb-1">
                <strong>ID:</strong> {{integracaoFood99.lojaSelecionada.id}}
              </p>
              <p class="mb-0 text-muted" *ngIf="integracaoFood99.lojaSelecionada.address">
                {{integracaoFood99.lojaSelecionada.address}}
              </p>
            </div>
          </div>

          <div class="text-right mt-3">
            <button class="btn btn-success"
                    type="button"
                    (click)="ativeLojaSelecionada()"
                    [disabled]="ativando || !integracaoFood99.lojaSelecionada">
              <i class="k-icon k-i-loading mr-2" *ngIf="ativando"></i>
              <i class="k-icon k-i-check mr-2" *ngIf="!ativando"></i>
              Concluir integração
            </button>
          </div>
        </div>
      </ng-container>
    </form>
  </div>
</div>

